import { useCallback, useState } from 'react';

import { ProductCard } from '../../ProductCard';
import { ShareModal } from './components/ShareModal';

import * as S from './Share.styles';

export type ProductCardShareProps = {
  positionRight?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  shareableProductData: Record<PropertyKey, any>;
};

export const Share = ({
  positionRight,
  shareableProductData,
}: ProductCardShareProps) => {
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const toggleModal = useCallback(
    (event?: Event) => {
      if (typeof event !== 'undefined') {
        event.preventDefault();
        event.stopPropagation();
      }
      setShareModalOpen(!shareModalOpen);
    },
    [shareModalOpen],
  );

  return (
    <S.ShareWrapper className='share-wrapper'>
      <ProductCard.ShareIcon
        onClick={toggleModal}
        positionRight={positionRight}
      />
      <ShareModal
        isOpen={shareModalOpen}
        onClose={toggleModal}
        shareableProductData={shareableProductData}
      />
    </S.ShareWrapper>
  );
};

Share.displayName = 'Share';
